import { Resource } from '../../hooks/useResources';

export const generateResources = (resources: Resource[]) => {
  return resources.map((resource: Resource) => resource.name);
};
